<template>
  <div class="sca-loading-cell">
    <SCASkeletonItem height="14px" />
  </div>
</template>

<script setup lang="ts">
import SCASkeletonItem from "../../../SCASkeletonItem.vue";
</script>

<style lang="scss">
// AG Grid mounts this cell outside the component tree, where $style is undefined.
.sca-loading-cell {
  display: flex;
  align-items: center;
  height: 100%;
}
</style>
